import * as React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface UploadExistsFilesConfirmationModalProps {
  handleAccept: () => void;
  handleClose: () => void;
}

export const UploadPermissionNotificationModel: React.FC<UploadExistsFilesConfirmationModalProps> = ({
  handleAccept,
  handleClose,
}) => {
  const [isOpen, setIsOpen] = React.useState(true);
  const accept = () => {
    handleAccept();
    setIsOpen(false);
  };

  const handleCancel = () => {
    handleClose();
    setIsOpen(false);
  };

  return (
    <Dialog
      open={isOpen}
      onOpenChange={open => {
        if (!open) handleCancel();
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Documents are being uploaded into a shared folder</DialogTitle>
        </DialogHeader>
        <div className="flex flex-grow flex-col space-y-4 overflow-hidden">
          <p className="text-md m-2 text-gray-500">
            Documents are being uploaded into a shared folder. Do you want to proceed ?
          </p>
        </div>
        <div className="mt-4 flex justify-between">
          <Button variant="outline" onClick={handleCancel} type="button">
            No
          </Button>

          <Button onClick={accept} type="button">
            Yes
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
